// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"358":"43219387","766":"fe3bd43b"}[chunkId] + ".chunk.js";
};